import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import * as common from './appRedux/actions/common';
import * as login from './appRedux/actions/login';
import * as tools from './util/tools';

function AxiosInterceptors(props) {
  axios.interceptors.request.use(
    (request) => {
      return request;
    },
    (error) => {},
  );

  axios.interceptors.response.use(
    (response) => {
      if (response.statusCode === 200) {
        let result = tools.getHttpResponseSuccess(response);
        if (!result.status && result.message !== '') {
          props.snackbarAction(true, result.message);
        }
      }
      return response;
    },
    (error) => {
      if (typeof error.response !== 'undefined') {
        let statusCode = error.response.status;
        if (statusCode === 403) props.logoutAction();
        let message = tools.getHttpResponseMessageError(error.response.data);
        props.snackbarAction(true, message);
      }
      return error;
    },
  );

  return <></>;
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logoutAction: () => dispatch(login.logoutAction()),
    snackbarAction: (status, message) => dispatch(common.snackbarAction(status, message)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AxiosInterceptors);
